export enum Locales {
  enGB = 'en-GB',
  cyGB = 'cy-GB',
  enCA = 'en-CA',
  enUS = 'en-US',
  nbNO = 'nb-NO',
}

export type Locale = {
  localeCode: Locales;
  label: string;
};

export function getAllLocales(): Locale[] {
  return [
    { localeCode: Locales.enGB, label: 'English' },
    { localeCode: Locales.cyGB, label: 'Cymraeg' },
    { localeCode: Locales.enCA, label: 'English (Canada)' },
    { localeCode: Locales.enUS, label: 'English (United States)' },
    { localeCode: Locales.nbNO, label: 'Norsk bokmål' },
  ];
}

export function getDetailsForLocales(activeLocales: string[]): Locale[] {
  return getAllLocales().filter(locale =>
    activeLocales.includes(locale.localeCode),
  );
}

export function getDetailsForLocale(targetLocale: Locales): Locale {
  return getDetailsForLocales([targetLocale])[0];
}
